// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../b2b/B2bStudent";
import { name2num, num2name, } from "./Error";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as Long, } from "../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        email: "",
        student: undefined,
        error: "ERROR_UNSPECIFIED",
        errorMsg: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.email !== undefined)
        result.email = tsValueToJsonValueFns.string(value.email);
    if (value.student !== undefined)
        result.student = encodeJson_1(value.student);
    if (value.error !== undefined)
        result.error = tsValueToJsonValueFns.enum(value.error);
    if (value.errorMsg !== undefined)
        result.errorMsg = tsValueToJsonValueFns.string(value.errorMsg);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.email !== undefined)
        result.email = jsonValueToTsValueFns.string(value.email);
    if (value.student !== undefined)
        result.student = decodeJson_1(value.student);
    if (value.error !== undefined)
        result.error = jsonValueToTsValueFns.enum(value.error);
    if (value.errorMsg !== undefined)
        result.errorMsg = jsonValueToTsValueFns.string(value.errorMsg);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.email !== undefined) {
        const tsValue = value.email;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.student !== undefined) {
        const tsValue = value.student;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.error !== undefined) {
        const tsValue = value.error;
        result.push([3, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.errorMsg !== undefined) {
        const tsValue = value.errorMsg;
        result.push([4, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.email = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.student = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.error = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.errorMsg = value;
    }
    return result;
}
